var React = require('react');

function StepCircle0448px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m3.731 32h-2.158v-4.628h-7.852V25.89l7.54-10.79h2.47v10.504h2.366v1.768h-2.366V32zm-7.696-6.396h5.538v-5.642c0-.884.026-1.768.078-2.652h-.078c-.52.988-.936 1.716-1.404 2.496l-4.134 5.746v.052z"}));
}

StepCircle0448px.displayName = "StepCircle0448px";

StepCircle0448px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0448px;

StepCircle0448px.default = StepCircle0448px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-04-48px.svg
// module id = 1155
// module chunks = 0